import script from "./InventoryChannels.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventoryChannels.vue?vue&type=script&setup=true&lang=ts"

import "./InventoryChannels.vue?vue&type=style&index=0&id=7a7d5194&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a7d5194"]])

export default __exports__